(function () {
  function init(root) {
    if (root._wm) return; root._wm = true;
    var track = root.querySelector('[data-wm-track]');
    var dotsWrap = root.querySelector('[data-wm-dots]');
    var prev = root.querySelector('[data-wm-prev]');
    var next = root.querySelector('[data-wm-next]');
    if (!track) return;
    var items = Array.prototype.slice.call(track.children);
    function perView() {
      if (!items.length) return 1;
      return Math.max(1, Math.round(track.clientWidth / items[0].getBoundingClientRect().width));
    }
    function pages() { return Math.max(1, items.length - perView() + 1); }
    function current() {
      var w = items[0] ? items[0].getBoundingClientRect().width : 1;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return Math.round(track.scrollLeft / (w + gap));
    }
    function go(i) {
      i = Math.max(0, Math.min(pages() - 1, i));
      var it = items[i]; if (!it) return;
      track.scrollTo({ left: it.offsetLeft - items[0].offsetLeft, behavior: 'smooth' });
    }
    function render() {
      var n = pages();
      root.classList.toggle('wm-slider--static', n <= 1);
      if (!dotsWrap) return;
      if (dotsWrap.children.length !== n) {
        dotsWrap.innerHTML = '';
        for (var i = 0; i < n; i++) {
          var b = document.createElement('button');
          b.type = 'button'; b.className = 'wm-slider-dot'; b.setAttribute('aria-label', 'Slide ' + (i + 1));
          (function (idx) { b.addEventListener('click', function () { go(idx); }); })(i);
          dotsWrap.appendChild(b);
        }
      }
      var c = current();
      Array.prototype.forEach.call(dotsWrap.children, function (d, i) { d.classList.toggle('is-active', i === c); });
      if (prev) prev.disabled = c <= 0;
      if (next) next.disabled = c >= n - 1;
    }
    if (prev) prev.addEventListener('click', function () { go(current() - 1); });
    if (next) next.addEventListener('click', function () { go(current() + 1); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(render); }, { passive: true });
    window.addEventListener('resize', render);
    render();
  }
  function all() { document.querySelectorAll('[data-wm-slider]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();
